import { apiClient } from "../apiClient";
export const HINH_THUC_TINH_MIEN_GIAM_ENDPOINT = "mien-giam/hinh-thuc-tinh";
export const hinhThucTinhApi = {
  SelectAll: () => apiClient.get(`${HINH_THUC_TINH_MIEN_GIAM_ENDPOINT}`),
};
